import { render, staticRenderFns } from "./CurriculumTemplates.vue?vue&type=template&id=62c0418e&scoped=true"
import script from "./CurriculumTemplates.vue?vue&type=script&lang=js"
export * from "./CurriculumTemplates.vue?vue&type=script&lang=js"
import style0 from "./CurriculumTemplates.vue?vue&type=style&index=0&id=62c0418e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0418e",
  null
  
)

export default component.exports